const sports = [
  "Archery",
  "Badminton",
  "Baseball",
  "Basketball",
  "Beer pong",
  "Board games",
  "Bowling",
  "Boxing",
  "Card games",
  "Combat sports",
  "Cricket",
  "Cycling",
  "Dancing",
  "Darts",
  "E-sports",
  "Football",
  "Golf",
  "Gymnastics",
  "Handball",
  "Hockey",
  "Kickboxing",
  "MMA",
  "Motor sports",
  "Party games",
  "Pickleball",
  "Ping pong",
  "Pool",
  "Rock climbing",
  "Rugby",
  "Running",
  "Skateboarding",
  "Skating",
  "Skiing",
  "Snowboarding",
  "Soccer",
  "Softball",
  "Spikeball",
  "Swimming",
  "Tennis",
  "Ultimate frisbee",
  "Volleyball",
  "Water sports",
  "Fitness",
];

export default sports;
